export default __webpack_public_path__ + "static/media/alert-account-red.e302e4d0.svg";